export enum MODAL_DATA_HOOKS {
  CONTENT = 'tpa-modal-content',
  OVERLAY = 'tpa-modal-overlay',
}
